import React from 'react';
import { useInView } from 'react-intersection-observer';

import MobileAppPopupContainer from 'src/components/Banners/MobileAppPopup';
import LazyDesktopAppBanner from 'src/components/Banners/DesktopAppBanner/LazyDesktopAppBanner';
import CookiesBanner from 'src/components/Banners/CookiesBanner';
import { isSSR } from 'src/helpers/ssr';

import Flights from '../../components/Flights/Flights';
import Testimonials from '../../containers/Testimonials';
import { Container } from '../../../../routes/styles';

import type { PropsFromRedux } from '.';

export const PackageRoute = (props: PropsFromRedux) => {
  const { isManualPackage, isRoulette, isHotelOnly, isMobile, isWhitelabel } =
    props;

  const { inView, ref } = useInView();

  return (
    <Container $isMobile={isMobile} ref={ref}>
      {!isManualPackage && !isHotelOnly && (
        <Flights isPackageRouteInView={inView} />
      )}

      {!isRoulette && <Testimonials />}

      <MobileAppPopupContainer />

      {!isMobile && !isSSR && !isWhitelabel ? <LazyDesktopAppBanner /> : null}
      {!isMobile && !isSSR && !isWhitelabel ? <CookiesBanner /> : null}
    </Container>
  );
};
